import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import HomeLayout from '@/views/Pages/HomeLayout.vue';
import PulseLayout from '@/views/Layout/PulseLayout';
import CommunityLayout from '@/views/Pages/CommunityLayout.vue';
import EnterpriseLayout from '@/views/Layout/EnterpriseLayout';

// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Portal
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Portal/Dashboard/Dashboard.vue');
const CeoSummary = () => import(/* webpackChunkName: "reports" */ '@/views/Portal/Reports/CeoSummary.vue');
const AgentProduction = () => import(/* webpackChunkName: "reports" */ '@/views/Portal/Reports/AgentProduction.vue');
const ConversionReports = () => import(/* webpackChunkName: "reports" */ '@/views/Portal/Reports/ConversionReports.vue');
const SourcesReports = () => import(/* webpackChunkName: "reports" */ '@/views/Portal/Reports/SourcesReport.vue');
const BusinessInfo = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/BusinessPlanning/BusinessInfo.vue');
const EconomicModel = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/BusinessPlanning/EconomicModel.vue');
const EconomicModelForm = () => import(/* webpackChunkName: "planning" */ '@/views/Components/Forms/EconomicModelForm.vue');
const OrgModel = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/BusinessPlanning/OrgModel.vue');
const BudgetModel = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/BusinessPlanning/BudgetModel.vue');
const LeadGenModel = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/BusinessPlanning/LeadGenModel.vue');
const GoalGap = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/GoalGap/GoalGap.vue');
const OldGoalGap = () => import(/* webpackChunkName: "planning" */ '@/views/Portal/GoalGap/OldGoalGap.vue');
const DailyItems = () => import(/* webpackChunkName: "iov" */ '@/views/Portal/DailyItems/DailyItems.vue');
const DailyItemsForm = () => import(/* webpackChunkName: "iov" */ '@/views/Components/Forms/DailyItemsForm.vue');
const Pipelines = () => import(/* webpackChunkName: "pipelines" */ '@/views/Portal/Pipelines/Pipelines.vue');
const PipelineForm = () => import(/* webpackChunkName: "pipelines" */ '@/views/Components/Forms/PipelineForm');
const PipelineReports = () => import(/* webpackChunkName: "reports" */ '@/views/Portal/Reports/PipelineReports.vue');
const TransferPipelineForm = () => import(/* webpackChunkName: "observatory" */ '@/views/Components/Forms/TransferPipelineForm.vue');
const Listings = () => import(/* webpackChunkName: "listings" */ '@/views/Portal/Listings/Listings.vue');
const Transactions = () => import(/* webpackChunkName: "transactions" */ '@/views/Portal/Transactions/Transactions.vue');
const TransactionForm = () => import(/* webpackChunkName: "transactions" */ '@/views/Components/Forms/TransactionForm.vue');
const Financials = () => import(/* webpackChunkName: "financials" */ '@/views/Portal/Financials/Financials.vue');
const FinancialReports = () => import(/* webpackChunkName: "reports" */ '@/views/Portal/Reports/Financials.vue');
const Team = () => import(/* webpackChunkName: "team" */ '@/views/Portal/Team/Team.vue');
const Account = () => import(/* webpackChunkName: "account" */ '@/views/Portal/Account/Account.vue');
const Documents = () => import(/* webpackChunkName: "documents" */ '@/views/Portal/Documents/Documents.vue');
const Onboarding = () => import(/* webpackChunkName: "pages" */ '@/views/Portal/Onboarding/Onboarding.vue');
const Notifications = () => import(/* webpackChunkName: "pages" */ '@/views/Portal/Notifications/Notifications.vue');
const Notification = () => import(/* webpackChunkName: "pages" */ '@/views/Portal/Notifications/Notification.vue');
const Subscriptions = () => import(/* webpackChunkName: "pages" */ '@/views/Portal/Subscriptions/Subscriptions.vue');
const Certifications = () => import(/* webpackChunkName: "pages" */ '@/views/Portal/Certifications/Certifications.vue');
const Integrations = () => import(/* webpackChunkName: "integrations" */ '@/views/Portal/Integrations/Integrations.vue');
const FollowUpBoss = () => import(/* webpackChunkName: "integrations" */ '@/views/Portal/Integrations/FollowUpBoss.vue');
const QuickBooks = () => import(/* webpackChunkName: "integrations" */ '@/views/Portal/Integrations/QuickBooks.vue');
const QuickBooksAuthorize = () => import(/* webpackChunkName: "integrations" */ '@/views/Portal/Integrations/QuickBooksAuthorize.vue');
const Competitions = () => import(/* webpackChunkName: "competitions" */ '@/views/Portal/Competitions/Competitions.vue');
const Competition = () => import(/* webpackChunkName: "competitions" */ '@/views/Portal/Competitions/Competition.vue');
const CompetitionForm = () => import(/* webpackChunkName: "competitions" */ '@/views/Components/Forms/CompetitionForm.vue');
const Communities = () => import(/* webpackChunkName: "communities" */ '@/views/Portal/Communities/Communities.vue');
const CommunityTracking = () => import(/* webpackChunkName: "communities" */ '@/views/Portal/Communities/CommunityTracking.vue');
const CommunityTrackingForm = () => import(/* webpackChunkName: "communities" */ '@/views/Components/Forms/CommunityTrackingForm.vue');

// Observatory
const Observatory = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Observatory.vue');
const ObservedDashboard = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Dashboard/Dashboard.vue');
const ObservedCeoSummary = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Reports/CeoSummary.vue');
const ObservedAgentProduction = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Reports/AgentProduction.vue');
const ObservedConversionReports = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Reports/ConversionReports.vue');
const ObservedSourcesReports = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Reports/SourcesReport.vue');
const ObservedBusinessInfo = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/BusinessPlanning/BusinessInfo.vue');
const ObservedEconomicModel = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/BusinessPlanning/EconomicModel.vue');
const ObservedEconomicModelForm = () => import(/* webpackChunkName: "planning" */ '@/views/Components/Forms/ObservedEconomicModelForm.vue');
const ObservedOrgModel = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/BusinessPlanning/OrgModel.vue');
const ObservedBudgetModel = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/BusinessPlanning/BudgetModel.vue');
const ObservedLeadGenModel = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/BusinessPlanning/LeadGenModel.vue');
const ObservedGoalGap = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/GoalGap/GoalGap.vue');
const ObservedDailyItems = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/DailyItems/DailyItems.vue');
const ObservedDailyItemsForm = () => import(/* webpackChunkName: "observatory" */ '@/views/Components/Forms/DailyItemsForm.vue');
const ObservedPipelines = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Pipelines/Pipelines.vue');
const ObservedPipelineForm = () => import(/* webpackChunkName: "observatory" */ '@/views/Components/Forms/PipelineForm');
const ObservedPipelineReports = () => import(/* webpackChunkName: "reports" */ '@/views/Observatory/Reports/PipelineReports.vue');
const ObservedTransferPipelineForm = () => import(/* webpackChunkName: "observatory" */ '@/views/Components/Forms/TransferPipelineForm.vue');
const ObservedListings = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Listings/Listings.vue');
const ObservedTransactions = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Transactions/Transactions.vue');
const ObservedTransactionForm = () => import(/* webpackChunkName: "observatory" */ '@/views/Components/Forms/TransactionForm.vue');
const ObservedFinancials = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Financials/Financials.vue');
const ObservedFinancialReports = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Reports/Financials.vue');
const ObservedTeam = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Team/Team.vue');
const ObservedAccount = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Account/Account.vue');
const ObservedDocuments = () => import(/* webpackChunkName: "observatory" */ '@/views/Observatory/Documents/Documents.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const BrilliantTribe = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/BrilliantTribe.vue');
const Verify = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Verify.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');
const Invitation = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Invitation.vue');
const ForgotPassword = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/ForgotPassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/ResetPassword.vue');
const VideoLibrary = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/VideoLibrary.vue');
const Podcast = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Podcast.vue');
const Unsubscribe = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Unsubscribe.vue');

// Pulse
const Pulse = () => import(/* webpackChunkName: "pulse" */ '@/views/Pulse/Pulse.vue');
const PulseScores = () => import(/* webpackChunkName: "pulse" */ '@/views/Pulse/Scores/Scores.vue');
const PulseLogin = () => import(/* webpackChunkName: "pulse" */ '@/views/Pages/PulseLogin.vue');
const PulseRegister = () => import(/* webpackChunkName: "pulse" */ '@/views/Pages/PulseRegister.vue');
const PulseUsers  = () => import(/* webpackChunkName: "pulse" */ '@/views/Pulse/PulseUsers.vue');
const PulseViewers = () => import(/* webpackChunkName: "pulse" */ '@/views/Pulse/PulseViewers.vue');
const ObservedPulse = () => import(/* webpackChunkName: "pulse" */ '@/views/Observatory/Pulse/Pulse.vue');
const ObservedPulseScores = () => import(/* webpackChunkName: "pulse" */ '@/views/Observatory/Pulse/Scores/Scores.vue');

// Enterprise
const EnterpriseRegister = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/EnterpriseRegister.vue');
const Enterprise = () => import(/* webpackChunkName: "pulse" */ '@/views/Enterprise/Enterprise.vue');
const EnterpriseUsers = () => import(/* webpackChunkName: "pulse" */ '@/views/Enterprise/Users.vue');
const EnterpriseSettings = () => import(/* webpackChunkName: "pulse" */ '@/views/Enterprise/Settings.vue');

//import middleware
import store from '@/store';
import auth from '@/middleware/auth';
import active from '@/middleware/active';
import guest from '@/middleware/guest';
import setupComplete from '@/middleware/setupComplete';
import portalAccess from '@/middleware/portalAccess';
import pulse from '@/middleware/pulse';
import pulseAdmin from '@/middleware/pulseAdmin';
import canAddEdit from '@/middleware/canAddEdit';
import owner from '@/middleware/owner';
import registered from '@/middleware/registered';
import verified from '@/middleware/verified';

let businessPlanningMenu = {
  path: '/business-planning',
  component: DashboardLayout,
  name: 'Business Planning',
  redirect: '/business-planning/business-info',
  children: [
    {
      path: 'business-info',
      name: 'Business Info',
      component: BusinessInfo,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'economic-model',
      name: 'Economic Model',
      component: EconomicModel,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'economic-model/:year/edit',
      name: 'Edit Economic Model',
      component: EconomicModelForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'organization-model',
      name: 'Org Model',
      component: OrgModel,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'budget-model',
      name: 'Budget Model',
      component: BudgetModel,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'lead-gen-model',
      name: 'Lead Gen Model',
      component: LeadGenModel,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let goalGapMenu = {
  path: '/goal-gap',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Goal/Gap',
      component: GoalGap,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let oldGoalGapMenu = {
  path: '/old-goal-gap',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Old Goal/Gap',
      component: OldGoalGap,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let dailyItemsMenu = {
  path: '/daily-tracking',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Daily Tracking',
      component: DailyItems,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'create',
      name: 'New Daily Tracking',
      component: DailyItemsForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: ':id',
      name: 'Edit Daily Tracking',
      component: DailyItemsForm,
      props: true,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let communitiesMenu = {
  path: '/communities',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Communities',
      component: Communities,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'community-tracking',
      name: 'Community Tracking',
      component: CommunityTracking,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'community-tracking/create',
      name: 'New Community Tracking',
      component: CommunityTrackingForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'community-tracking/:id',
      name: 'Edit Community Tracking',
      component: CommunityTrackingForm,
      props: true,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let pipelinesMenu = {
  path: '/pipelines',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Sales Pipeline',
      component: Pipelines,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'create',
      name: 'New Pipeline',
      component: PipelineForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: ':id',
      name: 'Edit Pipeline',
      component: PipelineForm,
      props: true,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: ':id/transfer',
      name: 'Transfer Pipeline',
      component: TransferPipelineForm,
      props: true,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let listingsMenu = {
  path: '/listings',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'All Listings',
      component: Listings,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'create',
      name: 'New Listing',
      component: TransactionForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess, owner]
      }
    },
    {
      path: ':id',
      name: 'Edit Listing',
      component: TransactionForm,
      props: true,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess, owner]
      }
    }
  ]
};

let transactionsMenu = {
  path: '/transactions',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'All Transactions',
      component: Transactions,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'create',
      name: 'New Transaction',
      component: TransactionForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess, owner]
      }
    },
    {
      path: ':id',
      name: 'Edit Transaction',
      component: TransactionForm,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess, owner]
      }
    },
  ]
};

let financialsMenu = {
  path: '/financials',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Financials',
      component: Financials,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
};

let reportsMenu = {
  path: '/reports',
  component: DashboardLayout,
  name: 'Reports',
  redirect: '/reports/ceo-summary',
  children: [
    {
      path: 'ceo-summary',
      name: 'CEO Summary',
      component: CeoSummary,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'agent-production',
      name: 'Agent Production',
      component: AgentProduction,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'lead-gen-conversions',
      name: 'Lead Gen & Conversion Reports',
      component: ConversionReports,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'lead-sources',
      name: 'Lead Sources',
      component: SourcesReports,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'pipeline',
      name: 'Pipeline',
      component: PipelineReports,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    },
    {
      path: 'financials',
      name: 'Profit & Loss',
      component: FinancialReports,
      meta: {
        middleware: [auth, active, setupComplete, portalAccess]
      }
    }
  ]
}

let notificationsMenu = {
  path: '/notifications',
  component: DashboardLayout,
  name: 'Notifications',
  redirect: '/notifications',
  children: [
    {
      path: '',
      name: 'All Notifications',
      component: Notifications,
      meta: {
        middleware: [auth]
      }
    },
    {
      path: ':id',
      name: 'View Notification',
      component: Notification,
      meta: {
        middleware: [auth]
      }
    },
  ]
}

let integrationsMenu = {
  path: '/integrations',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Integrations',
      component: Integrations,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    },
    {
      path: 'follow-up-boss',
      name: 'Follow Up Boss',
      component: FollowUpBoss,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    },
    {
      path: 'follow-up-boss/transfer',
      name: 'Follow Up Boss Transfers',
      component: FollowUpBoss,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    },
    {
      path: 'quickbooks',
      name: 'QuickBooks',
      component: QuickBooks,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    },
    {
      path: 'quickbooks/authorize',
      name: 'Authorize QuickBooks',
      component: QuickBooksAuthorize,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    }
  ]
}

let competitionsMenu = {
  path: '/competitions',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: 'Competitions',
      component: Competitions,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    },
    {
      path: 'create',
      name: 'New Competition',
      component: CompetitionForm,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    },
    {
      path: ':id',
      name: 'Competition',
      component: Competition,
      meta: {
        middleware: [auth, active, portalAccess]
      }
    }
  ]
}

let observatoryMenu = {
  path:'/observatory/:user',
  component: DashboardLayout,
  name: 'Observatory Dashboard',
  redirect: '/observatory/:user/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'Observatory Company Vital Signs',
      component: ObservedDashboard,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'reports/ceo-summary',
      name: 'Observatory CEO Summary',
      component: ObservedCeoSummary,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'reports/agent-production',
      name: 'Observatory Agent Production',
      component: ObservedAgentProduction,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'reports/lead-gen-conversions',
      name: 'Observatory Lead Gen & Conversion Reports',
      component: ObservedConversionReports,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'reports/lead-sources',
      name: 'Observatory Lead Sources',
      component: ObservedSourcesReports,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'reports/pipeline',
      name: 'Observatory Sales Pipeline',
      component: ObservedPipelineReports,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'reports/financials',
      name: 'Observatory Profit & Loss',
      component: ObservedFinancialReports,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'business-planning/business-info',
      name: 'Observatory Business Information',
      component: ObservedBusinessInfo,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'business-planning/economic-model',
      name: 'Observatory Economic Model',
      component: ObservedEconomicModel,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'business-planning/economic-model/:year/edit',
      name: 'Edit Observatory Economic Model',
      component: ObservedEconomicModelForm,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'business-planning/budget-model',
      name: 'Observatory Budget Model',
      component: ObservedBudgetModel,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'business-planning/lead-gen-model',
      name: 'Observatory Lead Gen Model',
      component: ObservedLeadGenModel,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'goal-gap',
      name: 'Observatory Goal/Gap',
      component: ObservedGoalGap,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'daily-tracking',
      name: 'Observatory Daily Tracking',
      component: ObservedDailyItems,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'daily-tracking/create',
      name: 'Observatory Create Daily Tracking',
      component: ObservedDailyItemsForm,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'daily-tracking/:id',
      name: 'Observatory Edit Daily Tracking',
      component: ObservedDailyItemsForm,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'pipelines',
      name: 'Observatory Pipelines',
      component: ObservedPipelines,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'pipelines/create',
      name: 'Observatory Create Sales Pipeline',
      component: ObservedPipelineForm,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'pipelines/:id',
      name: 'Observatory Edit Sales Pipeline',
      component: ObservedPipelineForm,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'pipelines/:id/transfer',
      name: 'Observatory Transfer Pipeline',
      component: ObservedTransferPipelineForm,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'listings',
      name: 'Observatory Listings',
      component: ObservedListings,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'listings/create',
      name: 'Observatory Create Listing',
      component: ObservedTransactionForm,
      meta: {
        middleware: [auth, active, canAddEdit],
        observatory: true
      }
    },
    {
      path: 'listings/:id',
      name: 'Observatory Edit Listing',
      component: ObservedTransactionForm,
      meta: {
        middleware: [auth, active, canAddEdit],
        observatory: true
      }
    },
    {
      path: 'transactions',
      name: 'Observatory Transactions',
      component: ObservedTransactions,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    },
    {
      path: 'transactions/create',
      name: 'Observatory Create Transaction',
      component: ObservedTransactionForm,
      meta: {
        middleware: [auth, active, canAddEdit],
        observatory: true
      }
    },
    {
      path: 'transactions/:id',
      name: 'Observatory Edit Transaction',
      component: ObservedTransactionForm,
      meta: {
        middleware: [auth, active, canAddEdit],
        observatory: true
      }
    },
    {
      path: 'financials',
      name: 'Observatory Financials',
      component: ObservedFinancials,
      meta: {
        middleware: [auth, active],
        observatory: true
      }
    }
  ]
}

let homePage = {
  path: '/',
  component: HomeLayout,
  redirect: '/home',
  children: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        noBodyBackground: true,
        middleware: [auth]
      }
    },
    {
      path: '/video-library',
      name: 'Video Library',
      component: VideoLibrary,
      meta: {
        noBodyBackground: true,
        middleware: [auth]
      }
    },
    {
      path: '/podcast',
      name: 'Podcast',
      component: Podcast,
      meta: {
        noBodyBackground: true,
        middleware: [auth]
      }
    }
  ]
}

let authPages = {
  path: '/',
  component: AuthLayout,
  children: [
    {
      path: '',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/year-end-sale',
      name: 'End of Year Sale',
      redirect: '/register'
    },
    {
      path: '/brilliant-tribe',
      name: 'Brilliant Tribe',
      component: BrilliantTribe,
    },
    {
      path: '/pulse-login',
      name: 'Pulse Login',
      component: PulseLogin
    },
    {
      path: '/pulse-register',
      name: 'Pulse Register',
      component: PulseRegister,
      meta: {
        middleware: [registered]
      }
    },
    {
      path: '/register/enterprise',
      name: 'Enterprise Register',
      component: EnterpriseRegister,
      meta: {
        middleware: [registered]
      }
    },
    {
      path: '/email/verify',
      name: 'Verify Email',
      component: Verify
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    {
      path: '/invitation/:token',
      name: 'Invitation',
      component: Invitation
    },
    {
      path: '/forgot-password',
      name: 'Forgot Password',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'Reset Password',
      component: ResetPassword
    },
    {
      path: '/unsubscribe',
      name: 'Unsubscribe',
      component: Unsubscribe
    },
    { path: '*', component: NotFound }
  ]
};

let pulseMenu = {
  path: '/pulse',
  component: PulseLayout,
  redirect: '/pulse/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'Pulse Dashboard',
      component: Pulse,
      meta: {
        pulse: true,
        middleware: [auth, pulse]
      } 
    },
    {
      path: 'weekly-scoreboard',
      name: 'Weekly Scoreboard',
      component: PulseScores,
      meta: {
        pulse: true,
        middleware: [auth, pulse]
      } 
    },
    {
      path: 'users',
      name: 'Pulse Users',
      component: PulseUsers,
      meta: {
        pulse: true,
        middleware: [auth, pulseAdmin]
      } 
    },
    {
      path: 'viewers',
      name: 'Pulse Viewers',
      component: PulseViewers,
      meta: {
        pulse: true,
        middleware: [auth, pulseAdmin]
      } 
    }
  ]
};

let observatoryPulseMenu = {
  path: '/observatory/:user/pulse',
  component: PulseLayout,
  redirect: '/observatory/:user/pulse/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'Observatory Pulse Dashboard',
      component: ObservedPulse,
      meta: {
        pulse: true,
        middleware: [auth],
        observatory: true
      } 
    },
    {
      path: 'weekly-scoreboard',
      name: 'Observatory Weekly Scoreboard',
      component: ObservedPulseScores,
      meta: {
        pulse: true,
        middleware: [auth],
        observatory: true
      } 
    }
  ]
};

let enterpriseMenu = {
  path: '/enterprise',
  component: EnterpriseLayout,
  redirect: '/enterprise/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'Enterprise Dashboard',
      component: Enterprise,
      meta: {
        middleware: [auth]
      } 
    },
    {
      path: 'users',
      name: 'Enterprise Users',
      component: EnterpriseUsers,
      meta: {
        middleware: [auth]
      },
    },
    {
      path: 'settings',
      name: 'Enterprise Settings',
      component: EnterpriseSettings,
      meta: {
        middleware: [auth]
      }
    }
  ]
}

const routes = [
  reportsMenu,
  businessPlanningMenu,
  goalGapMenu,
  oldGoalGapMenu,
  dailyItemsMenu,
  communitiesMenu,
  pipelinesMenu,
  listingsMenu,
  transactionsMenu,
  financialsMenu,
  notificationsMenu,
  integrationsMenu,
  competitionsMenu,
  observatoryMenu,
  homePage,
  pulseMenu,
  observatoryPulseMenu,
  enterpriseMenu,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Company Vital Signs',
        component: Dashboard,
        meta: {
          middleware: [auth, active, setupComplete, portalAccess]
        }
      },
      {
        path: 'onboarding',
        name: 'Onboarding',
        component: Onboarding,
        meta: {
          middleware: [auth, active, portalAccess],
          onboarding: true
        }
      },
      {
        path: 'documents',
        name: 'Documents',
        component: Documents,
        meta: {
          middleware: [auth, active, setupComplete, portalAccess]
        }
      },
      {
        path: 'team',
        name: 'Team',
        component: Team,
        meta: {
          middleware: [auth, active, setupComplete, portalAccess]
        }
      },
      {
        path: 'account-settings',
        name: 'Account Settings',
        component: Account,
        meta: {
          middleware: [auth]
        }
      },
      {
        path: 'observatory',
        name: 'Observatory',
        component: Observatory,
        meta: {
          middleware: [auth, active]
        }
      },
      {
        path: 'subscriptions',
        name: 'Subscriptions',
        component: Subscriptions,
        meta: {
          middleware: [auth, active, portalAccess]
        }
      },
      {
        path: 'certifications',
        name: 'Certifications',
        component: Certifications,
        meta: {
          middleware: [auth, active, portalAccess]
        }
      }
    ]
  },
  authPages,
]; 

export default routes;